import { useCallback } from 'react';

import { useTracking } from '@change-corgi/core-react/tracking';

import { useHasFiltersApplied, useSearchActions, useSearchResults } from '#src/app/pages/searchV2/shared/searchState';

type Result = ModelHookResult<
	{
		query: string;
		disableClearFilters: boolean;
	},
	{
		clearFilters: () => void;
	}
>;

export function useNoResultsScreen(): Result {
	const results = useSearchResults();
	const actions = useSearchActions();
	const hasFilters = useHasFiltersApplied();
	const track = useTracking();

	return {
		data: {
			query: results.query || '',
			disableClearFilters: !hasFilters,
		},
		actions: {
			clearFilters: useCallback(() => {
				if (hasFilters) {
					actions.clearAllFilters();
					void track('search', { q: results.query || '', context: 'clear_empty_results_button' });
				}
			}, [hasFilters, actions, results.query, track]),
		},
	};
}
